import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth Services
export const authService = {
  login: async (email, password) => {
    try {
      const response = await axios.post(`${API}/clients/login`, { email, password });
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  updatePassword: async (userId, newPassword) => {
    try {
      const response = await axios.post(`${API}/clients/password/update`, {
        userId,
        newPassword
      });
      return response.data;
    } catch (error) {
      console.error('Password update error:', error);
      throw error;
    }
  }
};

// Client Services
export const clientService = {
  getAll: async () => {
    try {
      const response = await axios.get(`${API}/clients/`);
      return response.data;
    } catch (error) {
      console.error('Get clients error:', error);
      throw error;
    }
  },

  getById: async (clientId) => {
    try {
      const response = await axios.get(`${API}/clients/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Get client error:', error);
      throw error;
    }
  },

  create: async (clientData) => {
    try {
      const response = await axios.post(`${API}/clients/`, clientData);
      return response.data;
    } catch (error) {
      console.error('Create client error:', error);
      throw error;
    }
  },

  update: async (clientId, updateData) => {
    try {
      const response = await axios.put(`${API}/clients/${clientId}`, updateData);
      return response.data;
    } catch (error) {
      console.error('Update client error:', error);
      throw error;
    }
  },

  delete: async (clientId) => {
    try {
      const response = await axios.delete(`${API}/clients/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Delete client error:', error);
      throw error;
    }
  }
};

// Transaction Services
export const transactionService = {
  getByClient: async (clientId) => {
    try {
      const response = await axios.get(`${API}/transactions/client/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Get transactions error:', error);
      throw error;
    }
  },

  create: async (transactionData) => {
    try {
      const response = await axios.post(`${API}/transactions/`, transactionData);
      return response.data;
    } catch (error) {
      console.error('Create transaction error:', error);
      throw error;
    }
  },

  getAll: async () => {
    try {
      const response = await axios.get(`${API}/transactions/`);
      return response.data;
    } catch (error) {
      console.error('Get all transactions error:', error);
      throw error;
    }
  }
};

// Document Services
export const documentService = {
  getByClient: async (clientId) => {
    try {
      const response = await axios.get(`${API}/documents/client/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Get documents error:', error);
      throw error;
    }
  },

  create: async (documentData) => {
    try {
      const response = await axios.post(`${API}/documents/`, documentData);
      return response.data;
    } catch (error) {
      console.error('Create document error:', error);
      throw error;
    }
  },

  getAll: async () => {
    try {
      const response = await axios.get(`${API}/documents/`);
      return response.data;
    } catch (error) {
      console.error('Get all documents error:', error);
      throw error;
    }
  }
};

// Contract Services
export const contractService = {
  getByClient: async (clientId) => {
    try {
      // Get admin-uploaded contracts from client_contracts collection
      const response = await axios.get(`${API}/admin-contracts/client/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Get contracts error:', error);
      return [];
    }
  },

  getAll: async () => {
    try {
      const response = await axios.get(`${API}/admin-contracts/`);
      return response.data;
    } catch (error) {
      console.error('Get all contracts error:', error);
      return [];
    }
  }
};

// Insurance Services
export const insuranceService = {
  getByClient: async (clientId) => {
    try {
      const response = await axios.get(`${API}/insurance/client/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Get insurance error:', error);
      return [];
    }
  },

  getAll: async () => {
    try {
      const response = await axios.get(`${API}/insurance/`);
      return response.data;
    } catch (error) {
      console.error('Get all insurance error:', error);
      return [];
    }
  }
};

// Loan Services
export const loanService = {
  getByClient: async (clientId) => {
    try {
      const response = await axios.get(`${API}/loans/client/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Get loans error:', error);
      return [];
    }
  },

  create: async (loanData) => {
    try {
      const response = await axios.post(`${API}/loans/`, loanData);
      return response.data;
    } catch (error) {
      console.error('Create loan error:', error);
      throw error;
    }
  },

  update: async (loanId, updateData) => {
    try {
      const response = await axios.put(`${API}/loans/${loanId}`, updateData);
      return response.data;
    } catch (error) {
      console.error('Update loan error:', error);
      throw error;
    }
  },

  getAll: async () => {
    try {
      const response = await axios.get(`${API}/loans/`);
      return response.data;
    } catch (error) {
      console.error('Get all loans error:', error);
      return [];
    }
  }
};

// Justificatifs Services
export const justificatifService = {
  getByClient: async (clientId) => {
    try {
      const response = await axios.get(`${API}/justificatifs/client/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Get justificatifs error:', error);
      return [];
    }
  },

  upload: async (clientId, type, file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('clientId', clientId);
      formData.append('type', type);

      const response = await axios.post(`${API}/justificatifs/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Upload justificatif error:', error);
      throw error;
    }
  },

  getAll: async () => {
    try {
      const response = await axios.get(`${API}/justificatifs/`);
      return response.data;
    } catch (error) {
      console.error('Get all justificatifs error:', error);
      return [];
    }
  },

  update: async (justificatifId, updateData) => {
    try {
      const response = await axios.put(`${API}/justificatifs/${justificatifId}`, updateData);
      return response.data;
    } catch (error) {
      console.error('Update justificatif error:', error);
      throw error;
    }
  },

  delete: async (justificatifId) => {
    try {
      const response = await axios.delete(`${API}/justificatifs/${justificatifId}`);
      return response.data;
    } catch (error) {
      console.error('Delete justificatif error:', error);
      throw error;
    }
  },

  download: async (justificatifId) => {
    try {
      const response = await axios.get(`${API}/justificatifs/download/${justificatifId}`, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      console.error('Download justificatif error:', error);
      throw error;
    }
  },

  // Créer un justificatif validé sans fichier (pour bank/MTrust)
  createValidated: async (clientId, type) => {
    try {
      const response = await axios.post(`${API}/justificatifs/create-validated`, {
        clientId,
        type
      });
      return response.data;
    } catch (error) {
      console.error('Create validated justificatif error:', error);
      throw error;
    }
  }
};

// Loan Flow Services
export const loanFlowService = {
  getByClient: async (clientId) => {
    try {
      const response = await axios.get(`${API}/loan-flow/client/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Get loan flow error:', error);
      return null;
    }
  },

  create: async (flowData) => {
    try {
      const response = await axios.post(`${API}/loan-flow/`, flowData);
      return response.data;
    } catch (error) {
      console.error('Create loan flow error:', error);
      throw error;
    }
  },

  update: async (flowId, updateData) => {
    try {
      const response = await axios.put(`${API}/loan-flow/${flowId}`, updateData);
      return response.data;
    } catch (error) {
      console.error('Update loan flow error:', error);
      throw error;
    }
  },

  getAll: async () => {
    try {
      const response = await axios.get(`${API}/loan-flow/`);
      return response.data;
    } catch (error) {
      console.error('Get all loan flows error:', error);
      return [];
    }
  },

  delete: async (flowId) => {
    try {
      const response = await axios.delete(`${API}/loan-flow/${flowId}`);
      return response.data;
    } catch (error) {
      console.error('Delete loan flow error:', error);
      throw error;
    }
  }
};

// Contact / Advisor Services
export const contactService = {
  // Advisor info
  getAdvisor: async () => {
    try {
      const response = await axios.get(`${API}/contact/advisor`);
      return response.data;
    } catch (error) {
      console.error('Get advisor error:', error);
      return null;
    }
  },

  getClientAdvisor: async (clientId) => {
    try {
      const response = await axios.get(`${API}/contact/advisor/client/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Get client advisor error:', error);
      return null;
    }
  },

  setClientAdvisor: async (clientId, advisorData) => {
    try {
      const response = await axios.put(`${API}/contact/advisor/client/${clientId}`, advisorData);
      return response.data;
    } catch (error) {
      console.error('Set client advisor error:', error);
      throw error;
    }
  },

  updateAdvisor: async (advisorData) => {
    try {
      const response = await axios.put(`${API}/contact/advisor`, advisorData);
      return response.data;
    } catch (error) {
      console.error('Update advisor error:', error);
      throw error;
    }
  },

  // Messages
  sendMessage: async (messageData) => {
    try {
      const response = await axios.post(`${API}/contact/messages`, messageData);
      return response.data;
    } catch (error) {
      console.error('Send message error:', error);
      throw error;
    }
  },

  getAllMessages: async () => {
    try {
      const response = await axios.get(`${API}/contact/messages`);
      return response.data;
    } catch (error) {
      console.error('Get all messages error:', error);
      return [];
    }
  },

  getClientMessages: async (clientId) => {
    try {
      const response = await axios.get(`${API}/contact/messages/client/${clientId}`);
      return response.data;
    } catch (error) {
      console.error('Get client messages error:', error);
      return [];
    }
  },

  markAsRead: async (messageId) => {
    try {
      const response = await axios.put(`${API}/contact/messages/${messageId}/read`);
      return response.data;
    } catch (error) {
      console.error('Mark as read error:', error);
      throw error;
    }
  },

  replyToMessage: async (messageId, reply) => {
    try {
      const response = await axios.put(`${API}/contact/messages/${messageId}/reply`, { reply });
      return response.data;
    } catch (error) {
      console.error('Reply to message error:', error);
      throw error;
    }
  },

  deleteMessage: async (messageId) => {
    try {
      const response = await axios.delete(`${API}/contact/messages/${messageId}`);
      return response.data;
    } catch (error) {
      console.error('Delete message error:', error);
      throw error;
    }
  }
};
